import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-24-水滴-空心",
  "use": "icon-24-水滴-空心-usage",
  "viewBox": "0 0 16 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 24\" id=\"icon-24-水滴-空心\">\n<g>\n\t<g>\n\t\t<path d=\"M8,2.46c1.01,2.02,2.23,3.85,3.35,5.51C13.31,10.91,15,13.44,15,16c0,4.37-2.03,6.73-6.03,7H8H7.03\n\t\t\tC3.03,22.73,1,20.37,1,16c0-2.56,1.69-5.09,3.65-8.03C5.77,6.31,6.99,4.48,8,2.46 M8,0C5.5,6.5,0,11,0,16c0,4.8,2.4,7.7,7,8\n\t\t\tc0.2,0,0.8,0,1,0s0.8,0,1,0c4.6-0.3,7-3.2,7-8C16,11,10.5,6.5,8,0L8,0z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol